import {PressureRange} from './pressure-range';
import {Utils} from '@astek/utils';

export class InfusionParametersResults {

  constructor(
    public outflowResistance: number,
    public needleResistance: number,
    public elastance: number,
    public basal: PressureRange,
    public plateau: PressureRange,
  ) {
  }

  public clone(): InfusionParametersResults {
    return new InfusionParametersResults(
      this.outflowResistance,
      this.needleResistance,
      this.elastance,
      this.basal.clone(),
      this.plateau.clone()
    );
  }

  public copy(other: InfusionParametersResults): this {
    this.outflowResistance = other.outflowResistance;
    this.needleResistance = other.needleResistance;
    this.elastance = other.elastance;
    this.basal.copy(other.basal);
    this.plateau.copy(other.plateau);
    return this;
  }

  public equals(other: InfusionParametersResults | null): boolean {
    if (Utils.isNullOrUndefined(other)) {
      return false;
    }
    return this.outflowResistance === other.outflowResistance
      && this.needleResistance === other.needleResistance
      && this.elastance === other.elastance
      && this.basal.equals(other.basal)
      && this.plateau.equals(other.plateau);
  }

}
